var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModeratorReticleInfoDiscardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 21L12 2L1 21H23ZM20.4 19.5H3.6L12 5L20.4 19.5ZM11.8956 18.075C11.6819 18.075 11.5042 18.0027 11.3625 17.8581C11.2208 17.7135 11.15 17.5344 11.15 17.3206C11.15 17.1069 11.2223 16.9292 11.3669 16.7875C11.5115 16.6458 11.6906 16.575 11.9044 16.575C12.1181 16.575 12.2958 16.6473 12.4375 16.7919C12.5792 16.9365 12.65 17.1156 12.65 17.3294C12.65 17.5431 12.5777 17.7208 12.4331 17.8625C12.2885 18.0042 12.1094 18.075 11.8956 18.075ZM12.65 15.3H11.15V9.7H12.65V15.3Z",
    fill: "#FF5050"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeratorReticleInfoDiscardIcon);
export default __webpack_public_path__ + "static/media/moderatorReticleInfoDiscardIcon.0bbb477f666938d9323e7efeb741c4df.svg";
export { ForwardRef as ReactComponent };